import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {RouteEditableListComponent} from "./components/route-editable-list/route-editable-list.component";
import {RouteEditableListItemComponent} from "./components/route-editable-list-item/route-editable-list-item.component";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {ScrollingModule as ScrollingModuleExperimental} from "@angular/cdk-experimental/scrolling";
import {AccountsModule} from "../../account/angular/accounts.module";
import {RoutesPanelListComponent} from "./components/routes-panel-list/routes-panel-list.component";
import {RoutesTableListComponent} from "./components/routes-table-list/routes-table-list.component";
import {RoutesPanelListItemComponent} from "./components/routes-panel-list-item/routes-panel-list-item.component";
import {AgentsModule} from "../../agents/angular/agents.module";
import {RoutesPanelRouteViewComponent} from "./components/routes-panel-route-view/routes-panel-route-view.component";
import {RoutesPanelRouteViewTaskItemComponent} from "./components/routes-panel-route-view-task-item/routes-panel-route-view-task-item.component";
import {RoutesTableRouteViewComponent} from "./components/routes-table-route-view/routes-table-route-view.component";
import {RoutesTableResourceViewComponent} from "./components/routes-table-resource-view/routes-table-resource-view.component";
import {ServicesModule} from "../../deliveries/angular/services.module";
import {TasksModule} from "../../tasks/angular/tasks.module";
import {RoutesTotalsBarComponent} from "./components/routes-totals-bar/routes-totals-bar.component";
import {
  RoutesPanelSortingDialogComponent
} from "./components/routes-panel-sorting-dialog/routes-panel-sorting-dialog.component";
import {
  RoutesPanelResourceViewComponent
} from "./components/routes-panel-resource-view/routes-panel-resource-view.component";
import {RoutesTableListRowComponent} from "./components/routes-table-list-row/routes-table-list-row.component";
import {ResourcesModule} from "../../resources/angular/resources.module";
import {
  ServiceSplitByPackagesComponent
} from "./components/service-split-by-packages/service-split-by-packages.component";
import {FormsModule} from "@angular/forms";


@NgModule({
  declarations: [
    RouteEditableListComponent,
    RouteEditableListItemComponent,
    RoutesPanelListComponent,
    RoutesTableListComponent,
    RoutesTableListRowComponent,
    RoutesPanelListItemComponent,
    RoutesPanelRouteViewComponent,
    RoutesPanelRouteViewTaskItemComponent,
    RoutesTableRouteViewComponent,
    RoutesTableResourceViewComponent,
    RoutesTotalsBarComponent,
    RoutesPanelSortingDialogComponent,
    RoutesPanelResourceViewComponent,
    ServiceSplitByPackagesComponent
  ],
  imports: [
    BrowserModule,
    CommonsModule,
    FormsModule,
    AccountsModule,
    AgentsModule,
    ServicesModule,
    TasksModule,
    NgbModule,
    ScrollingModule,
    ScrollingModuleExperimental,
    DragDropModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    ResourcesModule
  ],
  providers: [],
  exports: []
})

export class RoutesModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapRoutesModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(RoutesModule);
};

export const downgradedRoutesModule = downgradeModule(bootstrapRoutesModule);
